import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type SocketService from "cc-frontend/services/socket"

export default class BusySyncingModal extends Component {
  @service declare socket: SocketService
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    BusySyncingModal: typeof BusySyncingModal
  }
}
